import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FlujoVentaPaso } from '../../../_models/flujo-venta-paso';
import { TabViewCustom } from '../../../_models/tab-view-custom';
import { ListaItem } from '../../../_models/lista-item';
import { Plantilla } from '../../../_models/plantilla';

@Component( {
  selector: 'app-flujo-venta-historial-credito',
  templateUrl: 'flujo-venta-historial-credito.component.html'
} )

export class FlujoVentaHistorialCreditoComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() listasTiposProductosBancarios: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Input() lisAutorizaciones: ListaItem[] = [];
  @Input() lisPlantilla: Plantilla[] = [];
  @Input() lisFases: ListaItem[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() titulo: string;
  @Input() lisEstados: SelectItem[] = [];
  tabSeleccionado = 'DATGEN';

  constructor() {
  }

  ngOnInit() {
  }

  abrirAcordeon( evento: number ) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'DATGEN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'REINT';
        break;
      }
      case 2: {
        this.tabSeleccionado = 'PLANT';
        break;
      }
      case 3: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
      default: {
        break;
      }
    }
  }
}
